import {
  convertIAPIWiringInstructionsDataToIAPIWiringInstructionsResponse,
  convertIAPIWiringInstructionsResponseToIAPIWiringInstructionsData,
  IAPIWiringInstructionsData,
  IAPIWiringInstructionsResponse,
} from './IAPIWiringInstructions';
import {
  convertILicenseInfoDataToILicenseInfoResponse,
  convertILicenseInfoResponseToILicenseInfoData,
  ILicenseInfoData,
  ILicenseInfoResponse,
} from './ILicenseInfo';
import {
  convertIContactDataToIContactResponse,
  convertIContactResponseToIContactData,
  IContactData,
  IContactResponse,
} from './IContact';
import {
  convertIPropertyAddressDataToIAddressResponse,
  convertIAddressResponseToIPropertyAddressData,
  IAddressResponse,
} from '../Address/IAddress';
import { undefConversion } from '../../../utilities/shared/undefinedConversion';
import { IPropertyAddressData } from '../../address/IPropertyAddressData';

export interface IAPISettlementAgentResponse {
  name: string;
  email: string;
  phone: string;
  contact: IContactResponse;
  address: IAddressResponse;
  license_info?: ILicenseInfoResponse;
  wiring_info?: IAPIWiringInstructionsResponse;
}

export interface IAPISettlementAgentData {
  name: string;
  email: string;
  phone: string;
  contact: IContactData;
  address: IPropertyAddressData;
  licenseInfo?: ILicenseInfoData;
  wiringInfo?: IAPIWiringInstructionsData;
}

export const convertIAPISettlementAgentResponseToIAPISettlementAgentData = ({
  contact,
  address,
  license_info,
  wiring_info,
  ...rest
}: IAPISettlementAgentResponse): IAPISettlementAgentData => ({
  contact: convertIContactResponseToIContactData(contact),
  address: convertIAddressResponseToIPropertyAddressData(address),
  licenseInfo: undefConversion(convertILicenseInfoResponseToILicenseInfoData, license_info),
  wiringInfo: undefConversion(convertIAPIWiringInstructionsResponseToIAPIWiringInstructionsData, wiring_info),
  ...rest,
});

export const convertIAPISettlementAgentDataToIAPISettlementAgentResponse = ({
  contact,
  address,
  licenseInfo,
  wiringInfo,
  ...rest
}: IAPISettlementAgentData): IAPISettlementAgentResponse => ({
  contact: convertIContactDataToIContactResponse(contact),
  address: convertIPropertyAddressDataToIAddressResponse(address),
  license_info: undefConversion(convertILicenseInfoDataToILicenseInfoResponse, licenseInfo),
  wiring_info: undefConversion(convertIAPIWiringInstructionsDataToIAPIWiringInstructionsResponse, wiringInfo),
  ...rest,
});
